import { render, staticRenderFns } from "./Analytics.vue?vue&type=template&id=bbfa96c6&"
import script from "./Analytics.vue?vue&type=script&lang=js&"
export * from "./Analytics.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports